import React from 'react';
import axios from 'axios';
import { Box, Button, Card, CardContent, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InputAdornment from '@mui/material/InputAdornment';
import { useSnackbar } from 'notistack';
export default function ProfileTab(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(true);
    const [edit, setEdit] = React.useState(false);
    const [saving, setSaving] = React.useState(false);
    const [profile, setProfile] = React.useState({ first_name: '', last_name: '', email: '' });
    const load = React.useCallback(() => {
        setLoading(true);
        axios.get('/user/me', { headers: { Authorization: `Bearer ${props.token}` } })
            .then((response) => {
            var _a, _b, _c, _d, _e, _f;
            setProfile({
                first_name: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.first_name) !== null && _b !== void 0 ? _b : '',
                last_name: (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.last_name) !== null && _d !== void 0 ? _d : '',
                email: (_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.email) !== null && _f !== void 0 ? _f : '',
            });
        })
            .finally(() => setLoading(false));
    }, [props.token]);
    React.useEffect(() => { load(); }, [load]);
    const handleChange = (key, value) => {
        setProfile(prev => (Object.assign(Object.assign({}, prev), { [key]: value })));
    };
    const handleSave = () => {
        setSaving(true);
        axios.put('/user/me', { first_name: profile.first_name, last_name: profile.last_name }, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${props.token}` } }).then((response) => {
            var _a, _b, _c;
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) {
                enqueueSnackbar('Профиль сохранён', { variant: 'success', autoHideDuration: 1500 });
                setEdit(false);
                (_b = props.onSaved) === null || _b === void 0 ? void 0 : _b.call(props);
            }
            else {
                enqueueSnackbar(((_c = response.data) === null || _c === void 0 ? void 0 : _c.error) || 'Не удалось сохранить', { variant: 'error' });
            }
        }).catch(() => {
            enqueueSnackbar('Ошибка сохранения', { variant: 'error' });
        }).finally(() => setSaving(false));
    };
    if (loading) {
        return React.createElement(CircularProgress, { size: 24, sx: { m: 3 } });
    }
    return (React.createElement(Card, { variant: "outlined", sx: { borderRadius: 2, maxWidth: 600 } },
        React.createElement(CardContent, { sx: { p: 3 } },
            React.createElement(Typography, { variant: "subtitle1", fontWeight: 700, sx: { mb: 2.5 } }, "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"),
            React.createElement(Stack, { spacing: 2.5 },
                React.createElement(TextField, { label: "\u0418\u043C\u044F", variant: "filled", value: profile.first_name, disabled: !edit, onChange: e => handleChange('first_name', e.target.value), InputProps: {
                        startAdornment: (React.createElement(InputAdornment, { position: "start" },
                            React.createElement(PersonOutlineIcon, { fontSize: "small", color: "action" })))
                    } }),
                React.createElement(TextField, { label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F", variant: "filled", value: profile.last_name, disabled: !edit, onChange: e => handleChange('last_name', e.target.value), InputProps: {
                        startAdornment: (React.createElement(InputAdornment, { position: "start" },
                            React.createElement(BadgeOutlinedIcon, { fontSize: "small", color: "action" })))
                    } }),
                React.createElement(TextField, { label: "Email", variant: "filled", value: profile.email, disabled: true, InputProps: {
                        startAdornment: (React.createElement(InputAdornment, { position: "start" },
                            React.createElement(MailOutlineIcon, { fontSize: "small", color: "action" })))
                    } }),
                React.createElement(Box, null, !edit ? (React.createElement(Button, { variant: "contained", color: "success", onClick: () => setEdit(true) }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C")) : (React.createElement(Stack, { direction: "row", spacing: 1.5 },
                    React.createElement(Button, { variant: "contained", color: "success", disabled: saving, onClick: handleSave }, saving ? React.createElement(CircularProgress, { size: 16 }) : 'Сохранить'),
                    React.createElement(Button, { variant: "outlined", disabled: saving, onClick: () => { setEdit(false); load(); } }, "\u041E\u0442\u043C\u0435\u043D\u0430"))))))));
}
